import React from "react"

import classNames from "classnames"

import { connect } from "scrivito"
import { ProductInformation } from "shared/types/__generated__/graphql"

import { useProductPageAddonTitlesContext } from "../context/ProductPageAddonTitlesContext"

interface ProductPageAddonSectionTitleProps
  extends React.HTMLAttributes<HTMLDivElement> {
  productInformation: Pick<ProductInformation, "title" | "productType">
}

function ProductPageAddonSectionTitleComponent({
  className,
  children,
  productInformation,
  ...props
}: ProductPageAddonSectionTitleProps) {
  const { titleByProductType } = useProductPageAddonTitlesContext()

  const title =
    titleByProductType[productInformation.productType] ||
    productInformation.title

  if (!title) {
    return null
  }

  return (
    <h2
      {...props}
      className={classNames("product-page__product-section-title", className)}
    >
      {children || title}
    </h2>
  )
}

export const ProductPageAddonSectionTitle = React.memo(
  connect(ProductPageAddonSectionTitleComponent)
) as typeof ProductPageAddonSectionTitleComponent
